export const API_LINK = "https://api.artic.edu/docs/";

export const TELEGRAM_LINK = "https://t.me/iwishyoujoy";
export const GITHUB_LINK = "https://github.com/iwishyoujoy";